export default __webpack_public_path__ + "static/media/Track Platooning case study.f280efbc.pdf";